import { isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";
import { FiasRegion } from "../../../Types/FiasTypes";
import { FiasApi, RegionsType } from "../../../FiasApi";

export async function getRegionByCode(regionCode: string, apiClient: FiasApi): Promise<FiasRegion | undefined> {
    const regions = await apiClient.fetchRegions();
    return regions.find(x => x.region.code?.substring(0, 2) === regionCode)?.region;
}

export async function getRegionNameByCode(
    regionCode: string | undefined,
    apiClient: FiasApi
): Promise<string | undefined> {
    if (isNullOrEmpty(regionCode)) {
        return undefined;
    }
    const regions = await apiClient.fetchRegions();
    const region = regions.find(x => x.region.code?.substring(0, 2) === regionCode)?.region;
    if (region == undefined) {
        return undefined;
    }
    return `${region.name} ${region.abbreviation}`;
}

export const findRegionCodeByName = (regionName: string, regionsList?: RegionsType): string | undefined =>
    regionsList?.find(
        ({ region }) =>
            region.official === regionName || region.nameWithAbbreviation === regionName || region.name === regionName
    )?.region.code;

export function extractRegionCode(regionCode: string | undefined): string | undefined {
    if (isNullOrEmpty(regionCode)) {
        return undefined;
    }
    return regionCode.substring(0, 2);
}

export const buildFullRegionCode = (code: string): string => {
    if (code.length === 2) {
        return `${code}00000000000`;
    }

    return code;
};
